import PropTypes from 'prop-types'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'
import CardShowcaseEvent from '@components/card-showcase-event'
import CardEventCta from '@components/card-event-cta/card-event-cta'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import useStyles from './showcase-event.styles'

const ShowcaseEvent = (props) => {
  const { sectionHeadline } = props
  const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'))
  const styles = useStyles()

  return (
    <Box className={styles.root}>
      <Container className={styles.contentWrapper}>
        <Typography variant="h4" className={styles.headline}>{sectionHeadline || 'Showcase Event'}</Typography>
        {isMobile
          ? <CardEventCta {...props} />
          : <CardShowcaseEvent {...props} />
        }
      </Container>
    </Box>
  )
}

ShowcaseEvent.propTypes = {
  headline: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  slug: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  sectionHeadline: PropTypes.string,
}

ShowcaseEvent.defaultProps = {}

export default ShowcaseEvent
